import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { PrismicReusableContentDataBodyTextAndImage } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import clsx from "clsx";
import { graphql } from "gatsby";

export const query = graphql`
  fragment TextAndImageModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyTextAndImage {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        image {
          gatsbyImageData
          url
          alt
        }
      }
    }
  }
`;

export type ITextAndImageProps = {
  slice: PrismicReusableContentDataBodyTextAndImage;
};

const TextAndImage = (props: ITextAndImageProps) => {
  const { slice } = props;
  const { primary } = slice;

  return (
    <div
      className={clsx([
        "bg-[#E6F0FD] rounded-lg text-center p-8 lg:p-16 min-h-[300px]",
        "[&_h6]:!text-[#0E6AED] [&_h6]:!font-bold",
        "[&_h5]:!text-[#0E6AED]",
        "[&_p]:text-lg [&_p]:text-[#476175]",
        "!grid grid-flow-row gap-8",
        "justify-items-center",
        primary?.css_class,
      ])}
    >
      <header>
        <PrismicRichText
          field={primary.heading.richText}
          components={htmlSerializer}
        />
      </header>
      <div
        className={clsx([
          "!grid grid-flow-rows lg:grid-flow-cols lg:grid-cols-12",
          "gap-8 justify-items-center content-center",
        ])}
      >
        <div className="image lg:!col-span-5 [&_div]:max-w-none">
          <GatsbyImage
            image={primary.image?.gatsbyImageData}
            alt={primary.image?.alt || "Xometry Resources"}
            loading="lazy"
            className="[&_img]:!object-contain w-full [&>div]:!max-w-none"
          />
        </div>
        <div className="text lg:text-left self-center lg:!col-span-7">
          <PrismicRichText
            field={primary.description.richText}
            components={htmlSerializer}
          />
        </div>
      </div>
    </div>
  );
};

export default TextAndImage;
